// Maps audit-log / activity entries to the back-office page that owns them.
// Used by the dashboard's recent-activity rows, the TopBar's notification
// popover, and the audit page's target column.
//
// Backend `entityType` is a closed Postgres ENUM (see /Users/loft/tkt-backend
// src/models/AuditLog.ts:7,28): 'order' | 'ticket' | 'scan_item' | 'payment'
// | 'user' | 'event'. Anything else from the action/metadata falls through
// to the prefix fallback (mock/legacy data) and finally 'audit'.

// The detail route an audit entry's subject opens (entityById's REGISTRY names and resolves it).
const SUBJECT_ROUTE: Record<string, string> = {
  event: 'event-detail', order: 'order-detail', payment: 'order-detail', payout: 'payout-detail',
  organization: 'organizer-detail', venue: 'venue-detail', box_office: 'box-office-detail', user: 'customer-detail',
};
export const subjectRoute = (entityType?: string | null) => SUBJECT_ROUTE[(entityType || '').toLowerCase()] || null;

const ACTIVITY_TARGET_PAGES: Record<string, string> = {
  order: 'orders',
  orders: 'orders',
  ticket: 'orders',
  tickets: 'orders',
  scan_item: 'access-control',
  scanItem: 'access-control',
  payment: 'transactions',
  payments: 'transactions',
  transaction: 'transactions',
  transactions: 'transactions',
  txn: 'transactions',
  user: 'people',
  users: 'people',
  customer: 'people',
  staff: 'people',
  event: 'events',
  events: 'events',
  // Legacy / mock-data aliases — kept for backwards compat with offline mocks.
  payout: 'payouts',
  payouts: 'payouts',
  payout_batch: 'payouts',
  request: 'event-requests',
  'event-request': 'event-requests',
  event_request: 'event-requests',
  template: 'design',
  design: 'design',
  campaign: 'design',
  message_template: 'design',
  risk: 'risk',
  case: 'risk',
  dispute: 'risk',
  chargeback: 'risk',
  // A settlement lives on Payouts (the settlement detail); the old reconciliation page was a mock.
  settlement: 'payouts',
  reconciliation: 'transactions',
};

const ACTIVITY_TARGET_PREFIXES: [RegExp, string][] = [
  [/^PAY-/i, 'payouts'],
  [/^TXN-/i, 'transactions'],
  [/^ORD-/i, 'orders'],
  [/^REQ-/i, 'event-requests'],
  [/^EVT-/i, 'events'],
  [/^TPL-/i, 'design'],
  [/^RSK-/i, 'risk'],
  [/^STL-/i, 'payouts'],
  [/^USR-/i, 'people'],
];

export const resolveActivityTargetPage = (item: { entityType?: string; target?: string } | null | undefined): string => {
  if (!item) return 'audit';
  const type = (item.entityType || '').toLowerCase();
  if (type && ACTIVITY_TARGET_PAGES[type]) return ACTIVITY_TARGET_PAGES[type];
  const target = String(item.target || '');
  for (const [re, page] of ACTIVITY_TARGET_PREFIXES) {
    if (re.test(target)) return page;
  }
  return 'audit';
};
